// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__QrU8H","rotate4":"Loader_rotate4__1gS1E","spinnerCircle":"Loader_spinnerCircle__sIbXj","dash4":"Loader_dash4__+h5L-"};